import React, { useState } from 'react';
import styles from './SupportTicket.module.css';


const SupportTicket = (props) => {

    const [showMore, setShowMore] = useState(false);

    const formatDate = (dateString) => {
        const dateToConvert = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }


    const makeTag = (value) => {
        switch (value) {
            case 'high':
                return <span className={`${styles['tag']} ${styles[value]}`}>High</span>;
            case 'medium':
                return <span className={`${styles['tag']} ${styles[value]}`}>Medium</span>;
            case 'low':
                return <span className={`${styles['tag']} ${styles[value]}`}>Low</span>;
            case 'open':
                return <span className={`${styles['tag']} ${styles[value]}`}>Open</span>;
            case 'closed':
                return <span className={`${styles['tag']} ${styles[value]}`}>Closed</span>;
            case 'rejected':
                return <span className={`${styles['tag']} ${styles[value]}`}>Rejected</span>;
            default:
                return <span className={`${styles['tag']} ${styles[value]}`}>{value}</span>;
        }
    };


    function normalizeString(str) {
        try {
            return str
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ') + ' ';
        }
        catch {
            return str ;
        }
    }

    return (
        <div className={styles['support-ticket-main']}>
            <div className={styles['support-ticket-container']}>
                <div className={styles['left-container']}>
                    <span>{normalizeString(props.ticket.mainIssueType ? props.ticket.mainIssueType : props.ticket.issueType)}</span> 
                    {makeTag(props.ticket.status)}
                </div>
                <div className={styles['right-container']}>
                    <span className={styles['date-container']}>{formatDate(props.ticket.date)}</span>
                    <span onClick={() => setShowMore(!showMore)} className={styles['show-more']}>{showMore ? 'Hide' : 'Show More'}</span>
                </div>
            </div>
            {showMore && <div className={styles['more-data']}>
                <div>Priority <b>{makeTag(props.ticket.priority)}</b></div>
                {/* <div className={styles['long-text']}>Issue <b>{normalizeString(props.ticket.mainIssueType)}</b></div> */}
                {props.ticket.mainIssueType !== null && <div className={styles['long-text']}>Issue Type <b>{normalizeString(props.ticket.mainIssueType)}</b></div>}
                {props.ticket.issueType !== null && <div className={styles['long-text']}>Issue Type <b>{normalizeString(props.ticket.issueType)}</b></div>}
                {props?.ticket?.description !== null && <div className={styles['long-text']}>description <b>{props.ticket.description}</b></div>}
                {props.ticket.date !== null && <div className={styles['long-text']}>Date <b>{formatDate(props.ticket.date)}</b></div>}
                {props.ticket.refundStatus && <div className={styles['long-text']}>Refund Status <b>{props.ticket.refundStatus ? 'Successfully refunded' : ''}</b></div>}
                {props.ticket.refundStatus && <div className={styles['long-text']}>Refund Amount <b>${props.ticket.refundAmount}</b></div>}
                {props.ticket.status && <div>Status <b>{makeTag(props.ticket.status)}</b></div>}

            </div>}
        </div>
    );
}




export default SupportTicket;